var y = /* @__PURE__ */ ((e) => (e.day = "day", e.week = "week", e.month = "month", e.year = "year", e))(y || {});
export {
  y as SubscriptionIntervalEnum
};
